import { render, staticRenderFns } from "./disbursement-profile.vue?vue&type=template&id=2742db45&scoped=true&"
import script from "./disbursement-profile.vue?vue&type=script&lang=js&"
export * from "./disbursement-profile.vue?vue&type=script&lang=js&"
import style0 from "./disbursement-profile.vue?vue&type=style&index=0&id=2742db45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742db45",
  null
  
)

export default component.exports